import { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
const CONTROL_SIZE = 39;
export const controlStyles = ({ theme }) => css `
	width: ${pxToRem(CONTROL_SIZE)};
	height: ${pxToRem(CONTROL_SIZE)};
	font-size: 0;
	cursor: pointer;
	pointer-events: auto;
	color: ${theme.colors.highlight.iconInteractive};
	background-color: ${theme.colors.blanc.bgPanelReview};
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.light.borderGallerySlider};
	border-radius: ${theme.borderRadius.rounded}%;
	display: block;

	&:hover {
		border-color: ${theme.colors.highlight.borderHover};
	}

	&:focus {
		outline: none;
	}
`;
//# sourceMappingURL=mixins.styled.js.map